export const serviceUUID = "6e400011-b5a3-f393-e0a9-e50e24dcca9e";
export const characteristicUUID_RX = "6e400012-b5a3-f393-e0a9-e50e24dcca9e"; // For sending commands to ESP32
export const characteristicUUID_TX = "6e400013-b5a3-f393-e0a9-e50e24dcca9e"; // For receiving notifications from ESP32

export const CAN_FUNC_TIME = 0x100;
export const CAN_FUNC_TX1 = 0x180;
export const CAN_FUNC_TX2 = 0x280;
export const CAN_FUNC_TX3 = 0x380;
export const CAN_FUNC_TX4 = 0x480;
export const CAN_FUNC_TX5 = 0x580;
export const CAN_FUNC_RX = 0x200;

export const LIGHTS_NODE_ID = 3;
export const LIGHTS_PROP_WHITE = 0x01; // White correction
export const LIGHTS_PROP_TIMER = 0x02; // Duration lights on
export const LIGHTS_PROP_COLOR = 0x03; // RGB Color of the lights
export const LIGHTS_PROP_BTN = 0x04; // Button pressed status
export const LIGHTS_PROP_LEDBAR = 0x05; // LED Bar timer
export const LIGHTS_PROP_LAYER_CONFIG = 0x06; // Layer configuration
export const LIGHTS_PROP_LAYER_EFFECT = 0x07; // Layer effect

export const HEATER_NODE_ID = 4;
export const HOT_WATER_NODE_ID = 5;

// Custom heater telemetry; reserve 0x584 for node 4 SDO responses.
export const HEATER_STATUS_CAN_ID = 0x504;
